import { InsiderTileBadgeRenderer } from "@faire/deprecated-retailer-visitor-shared/components/InsiderBadge/InsiderTileBadgeRenderer";
import { MaybeBrandReviewTile } from "@faire/deprecated-retailer-visitor-shared/components/MaybeBrandReviewTile/MaybeBrandReviewTile";
import { BrandInfoProps } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/brandInfoProps";
import { BrandMinimum } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/components/BrandMinimum";
import { BrandNameText } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/components/BrandNameText";
import { BrandPromoText } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/components/BrandPromoText";
import { BrandLink } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductTile/__internal__/components/BrandDetails/BrandLink";
import { ProductLink } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductTile/__internal__/components/ProductLink";
import { whichBatch10ProductTilesVariant } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingBatch10ProductTiles";
import { ISO_COUNTRY_TO_FLAG_ICON } from "@faire/icons/consts/ISO_COUNTRY_TO_FLAG_ICON";
import { IFourVariantXP } from "@faire/web-api--source/indigofair/settings/IFourVariantXP";
import { localNum } from "@faire/web/common/localization";
import { Column, Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";

export const BrandInfo = ({
  brandInfoProps,
}: {
  brandInfoProps?: BrandInfoProps;
}) => {
  const { isBatch10ProductTilesV2orV3, isBatch10ProductTilesV4 } =
    whichBatch10ProductTilesVariant(
      brandInfoProps?.batch10ProductTilesVariant ??
        IFourVariantXP.Bucket.CONTROL
    );
  if (!brandInfoProps) {
    return null;
  }
  return (
    <>
      {isBatch10ProductTilesV2orV3 || isBatch10ProductTilesV4 ? null : (
        <Spacer
          size={{
            mobileAndAbove: 4,
            tabletAndAbove: 8,
          }}
        />
      )}
      <Column gap={2} tabIndex={0}>
        <BrandLink>
          <BrandNameText
            brandToken={brandInfoProps.brandToken ?? ""}
            brandName={brandInfoProps.brandName ?? ""}
            isLoaded
            brandIcon={brandInfoProps.brandIcon}
            addUnderline={
              brandInfoProps.batch10ProductTilesVariant ===
              IFourVariantXP.Bucket.CONTROL
            }
            brandHoverData={
              brandInfoProps.catalogSizeText ||
              (brandInfoProps.images?.length ?? 0) > 0 ||
              brandInfoProps.bestImage
                ? {
                    catalogSizeText: brandInfoProps.catalogSizeText,
                    images: brandInfoProps.images,
                    bestImage: brandInfoProps.bestImage,
                  }
                : undefined
            }
          />
        </BrandLink>
        <ProductLink>
          <Column gap={2}>
            <BrandMinimum
              minimumOrderAmount={brandInfoProps.minimumOrderAmount}
              avgBrandReviewRating={brandInfoProps.avgBrandReviewRating}
              isLoggedInRetailer={brandInfoProps.isLoggedInRetailer}
            />
            {brandInfoProps.insiderBadgeProps.insiderLabelText ? (
              <InsiderTileBadgeRenderer {...brandInfoProps.insiderBadgeProps} />
            ) : null}
            <BrandPromoText
              promoText={brandInfoProps.brandPromoText}
              isHighlightedPromo={
                brandInfoProps.isHighlightedProductForPromotionalEvent
              }
            />
          </Column>
        </ProductLink>
        {!brandInfoProps.isLoggedInRetailer ? (
          <LoggedOutBrandInfo
            brandInfoProps={brandInfoProps}
            batch10ProductTilesVariant={
              brandInfoProps.batch10ProductTilesVariant ??
              IFourVariantXP.Bucket.CONTROL
            }
          />
        ) : null}
      </Column>
    </>
  );
};

const LoggedOutBrandInfo = ({
  brandInfoProps,
  batch10ProductTilesVariant,
}: {
  brandInfoProps: BrandInfoProps;
  batch10ProductTilesVariant: IFourVariantXP.Bucket;
}) => {
  const CountryFlag = brandInfoProps.flagCountryCode
    ? ISO_COUNTRY_TO_FLAG_ICON[brandInfoProps.flagCountryCode]
    : undefined;

  const { isBatch10ProductTilesV2orV3 } = whichBatch10ProductTilesVariant(
    batch10ProductTilesVariant
  );
  return (
    <>
      {isBatch10ProductTilesV2orV3 ? null : (
        <MaybeBrandReviewTile
          rating={ratingString(
            brandInfoProps.avgBrandReviewRating,
            brandInfoProps.brandReviewCount
          )}
        />
      )}
      {CountryFlag ? (
        <Row align="center">
          <CountryFlag fontSize="16px" />
          <Spacer width={6} />
          <Typography variant="paragraphSansRegular">
            {brandInfoProps.shipsFromMessage}
          </Typography>
        </Row>
      ) : null}
    </>
  );
};

const ratingString = (
  avgBrandReviewRating: string | undefined,
  brandReviewCount: number | undefined
) => {
  if (avgBrandReviewRating && brandReviewCount) {
    return `${avgBrandReviewRating} (${localNum(brandReviewCount)})`;
  }
  return undefined;
};
